export default "__VITE_ASSET__2a8542b2__"